import { ActivityView } from '@gkn-ili/views/dist/Activities';
import { ActivityGroupView, RoutingItemStepView, RoutingItemView } from '@gkn-ili/views/dist/OrderDocumentation';
import * as XLSX from 'xlsx';

function formatActivity(
  routingItem: RoutingItemView,
  step: RoutingItemStepView,
  ag: ActivityGroupView,
  activity: ActivityView,
) {
  return {
    'Routing item': routingItem.name,
    'Routing step': step.name,
    'Activity group': ag.name,
    Activity: activity.name,
    Description: activity.recordDescription,
    Count: activity.count,
    'Unit cost': activity.unitCost,
    'Total cost': activity.totalCost,
  };
}
function formatAG(routingItem: RoutingItemView, step: RoutingItemStepView, ag: ActivityGroupView) {
  return [
    { 'Routing item': routingItem.name, 'Routing step': step.name, 'Activity group': ag.name },
    ...Object.values(ag.activities).flatMap((act) => formatActivity(routingItem, step, ag, act)),
  ];
}
function formatStep(routingItem: RoutingItemView, step: RoutingItemStepView) {
  return [
    { 'Routing item': routingItem.name, 'Routing step': step.name },
    ...Object.values(step.activityGroups).flatMap((ag) => formatAG(routingItem, step, ag)),
  ];
}

function formatRoutingItem(routingItem: RoutingItemView) {
  const r = Object.values(routingItem.steps).flatMap((step) => formatStep(routingItem, step));
  return [{ 'Routing item': routingItem.name }, ...r];
}

export function exportTimeSheetWorkbook(routingItem: RoutingItemView) {
  const data = formatRoutingItem(routingItem);

  const workbook = XLSX.utils.book_new();
  const sheet = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, sheet, 'timesheet');

  XLSX.writeFileXLSX(workbook, 'timesheet.xlsx');
}
